import { render, staticRenderFns } from "./ChecklistInstance.vue?vue&type=template&id=cb8634d0&scoped=true"
import script from "./ChecklistInstance.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistInstance.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistInstance.vue?vue&type=style&index=0&id=cb8634d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8634d0",
  null
  
)

export default component.exports